import React from 'react';
import ClientService from '../client/ClientService';
import ChefService from '../chef/ChefService';
import withUser from '../auth/withUser';
import withTracker from '../withTracker';

const ServiceViewSwitch = props => {
  const { user } = props;
  return ServiceViewSwitchByUser(user.role, props);
};
export default withUser(withTracker(ServiceViewSwitch));

export const ServiceViewSwitchByUser = (role, props = {}) =>
  ({
    client: <ClientService {...props} />,
    chef: <ChefService {...props} />
  }[role] || <ClientService {...props} />);
// })[role] || <ChefService {...props} />;



// WEBPACK FOOTER //
// ./src/components/service/ServiceViewSwitch.js